import React from 'react';

import Banners from "../components/onboarding/banners";
import Terms from "../components/onboarding/terms";
import KDialog from "../components/kdialog";
import { Grid } from '@material-ui/core';
import Typography from "@material-ui/core/Typography";
import CircularProgress from '@material-ui/core/CircularProgress';

import api from "../api";

const errorMsgAllFiledsRequired = 'Please agree to all terms.';


class StepTnC extends React.Component {
  constructor(props) {
    super(props);
    this.onTermCheckCallback = this.onTermCheckCallback.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.state = {
      terms: props.getStore().center.terms,
      banners: props.getStore().center.banners,
      showAlert: false,
      alertMessages: [],
      alertTitle: '',
      userMsg: '',
      busy: false
    };
    this.onAlertClose = this.onAlertClose.bind(this);
    this.promoNA = props.getStore().user.promoNA;    

   
  }

  handleModalClose = () => this.setState((state, props) => {
    return { isOpen: false };
  });

  isValidated() {
    let isDataValid = false;
    let terms = this.state.terms;

    if (Object.keys(terms).every((k) => { return terms[k].checked === true })) {
      this.showModal = false;

      isDataValid = true;
      let center = Object.assign({}, this.props.getStore().center); //, terms );  
      center.terms = Object.assign(center.terms, terms);
      let stData = { center: center }
      this.props.updateStore({
        ...stData,
        savedToCloud: false
      });
      isDataValid = this.getReviewItemsFromServer(this.props.getStore());
    }
    else {
      let alertMessages = [];
      alertMessages.push(errorMsgAllFiledsRequired);
      this.setState((state, props) => {
        return { showAlert: true, alertMessages: alertMessages };
      });
    }
    return isDataValid; 
  }


  async getReviewItemsFromServer(store) {
    this.setState({ busy: true, userMsg: '' });

    let token = store.user.token;
    let apiKey = store.user.apiKey;

    let revData = JSON.parse(JSON.stringify(store));

    delete revData.savedToCloud;
    delete revData.summaryMessage;
    let centerCopy = { id: revData.center.id }
    delete revData.center;
    revData.center = centerCopy;
    
    let user = revData.user;
    delete user.pin;
    delete user.token;
    delete user.apiKey;
    delete user.confirmBankAccount;
    delete user.confirmBankRouting;
    delete user.student_0;
    delete user.student_1;
    delete user.student_2;
    delete user.student_3;
    delete user.parentName;
    delete user.bankName;
    delete user.bankAccount;
    delete user.bankAccountType;
    delete user.bankRouting;
    delete user.accountHolderName;
    delete user.addressAddress;
    delete user.addressCity;
    delete user.addressCity;
    delete user.addressState;
    delete user.addressZip;
    delete user.signature;
    delete user.accountHolderPhone;
    delete user.sections;
    delete user.reviewTitle;
    delete user.options;

    let data = await api.user.review(apiKey, token, revData);
    if (data.success === true) {
      let user = Object.assign({}, this.props.getStore().user); //, terms );  
      user.sections = data.sections; //Object.assign(center.terms, sections);
      user.reviewTitle = data.reviewTitle
      let stData = { user: user }
      this.props.updateStore({
        ...stData,
        savedToCloud: false
      });
    }
    this.setState({ busy: false, userMsg: data.message });
    return data.success;
  }




  onTermCheckCallback = (data) => {
    let terms = this.state.terms;
    let term = terms.find(o => o.id === data.id);
    term.checked = data.checked;  
  }
  getStore = this.props.getStore;
  updateStore = this.props.updateStore;

  alertDlg = () => (
    this.state.showAlert ? <KDialog onAlertClose={this.onAlertClose} title='Center Policy' showAlert={true} messages={this.state.alertMessages} /> : ''
  )

  loading = () => (
    this.state.busy ? <CircularProgress /> : ''
  )
  userMessage = () => (
    this.state.userMsg === '' ? '' : <div className="alert alert-warning">{this.state.userMsg}</div>
  )

  onAlertClose() {
    this.setState((state, props) => {
      return { showAlert: false };
    });
  }

  render() {
    return (
      <div className="step step3">
        <div>
          <form id="Form" className="form-horizontal">
            <div className="form-group">
              <label className="col-md-12 control-label">
              <Typography                
              variant='h5'>
              Center Information &amp; Policies
            </Typography>

                <div className="your-class mt-3"></div>
              </label>
              <div className="containeraaa">
                <Banners banners={this.state.banners} promoNA={this.promoNA} />
                <div className="your-class mt-3 lead">
                <Typography                
              variant='subtitle1'>
                  Please go through the following sections and then click 'Yes, I Agree' against each section.
              </Typography>
                  </div>
                <div className="your-class mt-3"></div>
                <Terms termCallback={this.onTermCheckCallback} getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} terms={this.state.terms} />
              </div>
            </div>
            <Grid container spacing={3}>
              <Grid item xs={12} >
                {this.loading()}
                {this.userMessage()}
              </Grid>
            </Grid>
            <div className="your-class mt-3"></div>
          </form>
        </div >
        {this.alertDlg()}
      </div >
    );
  }
}

export default StepTnC;


